import { OFFER_SELECTED, DISPLAY_OFFERS } from './constants';

/**
 *
 * @param offer
 * @returns {{offer: *, type: *}}
 */
export function offerSelected(offer) {
  return {
    type: OFFER_SELECTED,
    offer,
  };
}

/**
 *
 * @param display
 * @returns {{display: *, type: *}}
 */
export function displayOffers(display = true) {
  return {
    type: DISPLAY_OFFERS,
    display,
  };
}
